import { createFileRoute } from '@tanstack/react-router';
import { RelatorioCadastroRelacaoClientesAniversariantes } from '@/features/relatorio/page/cadastro/relacao-clientes-aniversariantes/RelatorioCadastroRelacaoClientesAniversariantes';

export const Route = createFileRoute('/a/relatorio/cadastro/relacao-clientes-aniversariantes')({
    component: RelatorioCadastroRelacaoClientesAniversariantes,
});
